import { VideoRepresentation } from '../types';

export const getVideoAllowedDomainValue = (video: VideoRepresentation) =>
  video.privacy_settings?.allowed_domain || '';
